import { Component } from '@angular/core';

@Component({
  templateUrl: './user.component.html'
})
export class AdminCustomerUserComponent {

}
